import { Flex, Text, Link } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { FormContainer } from 'packages/logged-out/ui/FormContainer';
import { SignupForm } from 'packages/logged-out/ui/SignupForm';

type SignupFormContainerProps = {
  onSubmit: () => void;
};

export const SignupFormContainer: React.FC<SignupFormContainerProps> = ({
  onSubmit,
}) => {
  return (
    <Flex
      width={{ base: 'auto', sm: '380px', md: '400px', lg: '440px' }}
      justify="center"
      height="100%"
      direction="column"
      align="center"
      margin="0 auto"
      mb={{ base: '100px', md: '0' }}
      marginTop="5em"
    >
      <FormContainer>
        <SignupForm onSubmit={onSubmit} />
      </FormContainer>
      <Text mt="20px" fontSize="xs" align="center">
        Have an account?{' '}
        <Link as={RouterLink} color="teal" to="/">
          Sign in
        </Link>
      </Text>
    </Flex>
  );
};
